export const RETAILER_KEY_ALREADY_EXISTS_MESSAGE =
  "This Retailer Key already exists.";

export const RETAILER_NAME_REQUIRED_MESSAGE = "Retailer name is required";
export const RETAILER_KEY_REQUIRED_MESSAGE = "Retailer key is required";

function getErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === "string") {
    return error;
  }
  return "";
}

export function isRetailerKeyDuplicateError(error: unknown): boolean {
  const normalized = getErrorMessage(error).toLowerCase();
  return (
    normalized.includes("retailer key") ||
    normalized.includes("duplicate") ||
    normalized.includes("already exists")
  );
}

export function createRetailerNameRules() {
  return [{ required: true, message: RETAILER_NAME_REQUIRED_MESSAGE }];
}

export function createRetailerKeyRules() {
  return [{ required: true, message: RETAILER_KEY_REQUIRED_MESSAGE }];
}
